var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"restricted-enrollment-message-container text-center d-flex align-center justify-center"},[_c('div',[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }